import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8 3.33333V12.6667M3.33333 8H12.6667", stroke: "#1A2023", strokeWidth: 1.5, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgPlus);
export { ForwardRef as ReactComponent };
